module.exports = __webpack_public_path__ + "static/media/SF_bm_sekundaerlogo_postale_vestland_neg.488de799.png";